import styled, { css } from 'styled-components'

interface ProgressWidthProps {
  namePage: string
}

interface ProgressNumberProps {
  percentage: number
}

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
`

export const ProgressContainer = styled.div<ProgressWidthProps>`
  width: 240rem;

  ${(props) =>
    props.namePage === 'cardCourse' &&
    css`
      width: 80% !important;
    `}

  min-height: 6px;
  background: #c4c4c4;
  border-radius: 8px;
  @media (max-width: 600px) {
    width: 90%;
  }

  @media (max-width: 350px) {
    width: 85%;
  }
`

export const ProgressBar = styled.div<ProgressNumberProps>`
  width: ${(props) => props.percentage && `${props.percentage}%`};
  min-height: 6px;
  background: ${({ theme }) => `rgb(${theme.greenProgress.base})`};
  border-radius: 8px;
`

export const Percentage = styled.span`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: end;

  font-size: 0.875rem !important;
  line-height: 1.2rem !important;
  font-weight: 600 !important;
  color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  margin-bottom: 0 !important;
`
